export const normalizeReactQuillHtml = html => {
  if (!html || typeof html !== 'string') return '';

  let normalizedHtml = html;

  if (typeof document !== 'undefined') {
    const container = document.createElement('div');
    container.innerHTML = html;

    const textNodeFilter = typeof NodeFilter !== 'undefined' ? NodeFilter.SHOW_TEXT : 4;
    const walker = document.createTreeWalker(container, textNodeFilter);
    let currentNode = walker.nextNode();
    while (currentNode) {
      currentNode.nodeValue = currentNode.nodeValue.replace(/\u00a0/g, ' ');
      currentNode = walker.nextNode();
    }

    normalizedHtml = container.innerHTML;
  } else {
    normalizedHtml = normalizedHtml.replace(/&nbsp;/gi, ' ').replace(/\u00a0/g, ' ');
  }

  return normalizedHtml
    .replace(/<p><br><\/p>/gi, '')
    .replace(/<\/p>\s+<p\b/gi, '</p><p')
    .trim();
};
